var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-pane-wrapper", attrs: { id: "email-tab" } },
    [
      !_vm.loading
        ? _c("incident-message", {
            attrs: { "service-name": "nylas" },
            on: { update: _vm.handleIncidentUpdate },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isValidClientEmail
        ? _c(
            "div",
            {
              staticClass: "row my-5 justify-content-center align-items-center",
            },
            [
              _c(
                "div",
                { staticClass: "col-10 d-flex flex-column align-items-center" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("email.messages.noValidClientEmail")) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm.isValidClientEmail && !_vm.showEditor
        ? _c(
            "div",
            {
              staticClass: "row my-5 justify-content-center align-items-center",
            },
            [
              _c(
                "div",
                { staticClass: "col-10 d-flex flex-column align-items-center" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("email.messages.insertedValidEmail")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.reloadEditor },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("email.messages.startComposingYourEmail")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm.showEditor && _vm.ACCOUNT_HAS_EMAIL_SYNCED
        ? _c(
            "form",
            {
              ref: "emailForm",
              attrs: { id: "email-tab-form", autocomplete: "off" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-12" },
                  [
                    _c("select-email-field", {
                      attrs: {
                        "email-list": _vm.finalToList,
                        label: _vm.$t("email.to"),
                        "read-only":
                          !_vm.hasCoApplicants && !_vm.hasParticipants,
                        "allow-create": false,
                        multiple: false,
                      },
                      model: {
                        value: _vm.email.toList,
                        callback: function ($$v) {
                          _vm.$set(_vm.email, "toList", $$v)
                        },
                        expression: "email.toList",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "vue-simple-suggest",
                      {
                        ref: "templateAutocomplete",
                        attrs: {
                          list: _vm.emailTemplatesWithSubject,
                          "filter-by-query": "",
                          "display-attribute": "subject",
                          "value-attribute": "id",
                          styles: _vm.autocompleteStyles,
                          filter: _vm.emailTemplateSearch,
                        },
                        on: { select: _vm.openConfirmLoadTemplate },
                      },
                      [
                        _c("material-input", {
                          attrs: {
                            "on-type": "",
                            label: _vm.$t("email.optionalSubject"),
                          },
                          model: {
                            value: _vm.email.subject,
                            callback: function ($$v) {
                              _vm.$set(_vm.email, "subject", $$v)
                            },
                            expression: "email.subject",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("select-email-field", {
                      attrs: {
                        "email-list": _vm.ccListOptions,
                        label:
                          "" +
                          _vm.$options.filters.capitalize(_vm.$t("email.cc")),
                      },
                      model: {
                        value: _vm.email.ccList,
                        callback: function ($$v) {
                          _vm.$set(_vm.email, "ccList", $$v)
                        },
                        expression: "email.ccList",
                      },
                    }),
                    _vm._v(" "),
                    _c("select-email-field", {
                      attrs: {
                        "email-list": _vm.bccListOptions,
                        label:
                          "" +
                          _vm.$options.filters.capitalize(_vm.$t("email.bcc")),
                      },
                      model: {
                        value: _vm.email.bccList,
                        callback: function ($$v) {
                          _vm.$set(_vm.email, "bccList", $$v)
                        },
                        expression: "email.bccList",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-2 align-items-center" }, [
                      _c("div", { staticClass: "col-4" }, [
                        _c("div", { staticClass: "form-check pl-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email.scheduleDelivery,
                                expression: "email.scheduleDelivery",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: "scheduleDeliveryCheck",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.email.scheduleDelivery)
                                ? _vm._i(_vm.email.scheduleDelivery, null) > -1
                                : _vm.email.scheduleDelivery,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.email.scheduleDelivery,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.email,
                                          "scheduleDelivery",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.email,
                                          "scheduleDelivery",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.email, "scheduleDelivery", $$c)
                                  }
                                },
                                _vm.handleScheduleDeliveryChange,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "scheduleDeliveryCheck" },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("email.doNotDeliverBefore") ||
                                      "Do not deliver before"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c(
                            "field",
                            {
                              staticClass: "mb-0",
                              attrs: { name: "scheduledDate" },
                            },
                            [
                              _c("date-section", {
                                key: _vm.email.scheduleDelivery,
                                attrs: {
                                  value: _vm.email.scheduledDate,
                                  placeholder: "YYYY-MM-DD",
                                  "class-name": "valid-date future-date",
                                  disabled: !_vm.email.scheduleDelivery,
                                  "max-date": _vm.getMaxFutureDate(),
                                },
                                on: { change: _vm.handleScheduledDateChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-container form-group-material form-group-material-no-label position-relative fe-dp",
                          },
                          [
                            _c("vue-timepicker", {
                              staticClass: "text-gray",
                              attrs: {
                                id: "schedule-time",
                                "input-class":
                                  "material-input form-control p-0",
                                format: "hh:mm A",
                                "hour-label": "Hour",
                                "minute-label": "Minute",
                                "apm-label": "AM/PM",
                                "hide-clear-button": true,
                                placeholder: "  ",
                                disabled: !_vm.email.scheduleDelivery,
                              },
                              model: {
                                value: _vm.email.scheduledTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.email, "scheduledTime", $$v)
                                },
                                expression: "email.scheduledTime",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "d-none",
                                attrs: { for: "schedule-time" },
                              },
                              [_vm._v(_vm._s(_vm.$t("global.words.time")))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-8 col-12" },
                  [
                    _c("email-editor", {
                      ref: "emailEditor",
                      attrs: {
                        "email-signature": _vm.ACCOUNT_EMAIL_SIGNATURE,
                        "substitution-hints": true,
                        "show-merge-tags": true,
                        "show-application-merge-tags": false,
                        attachments: true,
                        "loaded-attachments": _vm.emailAttachments,
                        "generate-email": "",
                        "merge-tags": _vm.customFieldsTags,
                        hints: _vm.customFieldsHintsTags,
                        participants: _vm.participantsForMergeTags,
                        "generate-email-body": _vm.generatedEmailBody,
                      },
                      on: {
                        "attachment-change": _vm.handleAttachmentChange,
                        change: _vm.handleEditorChange,
                        "open-modal": _vm.showAutoComposeModal,
                      },
                    }),
                    _vm._v(" "),
                    _c("generate-ai-email-modal", {
                      ref: "generateEmailModal",
                      attrs: {
                        "show-tool-tip": false,
                        "button-text": "save",
                        "email-signature": _vm.ACCOUNT_EMAIL_SIGNATURE,
                        "client-profile": _vm.profile,
                      },
                      on: { "save-email": _vm.handleSaveGeneratedEmail },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "email-editor-templates",
                {
                  ref: "templatesToolbar",
                  attrs: {
                    "only-action-button": _vm.external,
                    "raw-html":
                      "" + _vm.email.html + _vm.ACCOUNT_EMAIL_SIGNATURE,
                    subject: _vm.email.subject,
                    attachments: _vm.emailAttachments,
                  },
                  on: {
                    clear: _vm.clearTemplate,
                    selected: _vm.handleTemplateSelect,
                  },
                },
                [
                  _c("div", { staticClass: "dropdown h-100" }, [
                    _c("div", {
                      ref: "addTipTooltip",
                      staticClass: "time-bomb-tooltip",
                      class: { disabled: _vm.disableSubmit },
                      attrs: {
                        disabled: _vm.disableSubmit,
                        title: "",
                        "data-original-title": _vm.$t(
                          "client-profile.messages.doubleClickToAdd"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "submitEmail",
                        staticClass:
                          "btn btn-primary clickable btn-sm submit-changes email-tab",
                        class: { "dropdown-toggle": !_vm.external },
                        attrs: {
                          role: "button",
                          "data-toggle": _vm.external ? null : "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false",
                          type: "button",
                          disabled: _vm.disableSubmit,
                        },
                        on: {
                          click: _vm.handleSubmitClick,
                          dblclick: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleSubmit.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.actions.sendEmail")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.external
                      ? _c(
                          "div",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { "aria-labelledby": "dropdownMenuLink" },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSendEmail(false)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.actions.sendEmail")) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSendEmail(true)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.actions.sendEmail")) +
                                    " +\n            " +
                                    _vm._s(
                                      _vm.$tc("global.words.activity", 1)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "row my-5 justify-content-center align-items-center",
            },
            [
              _c(
                "div",
                { staticClass: "col-10 d-flex flex-column align-items-center" },
                [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("email.messages.noLinkedEmail.0")) +
                        "\n        "
                    ),
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(_vm._s(_vm.$t("email.messages.noLinkedEmail.1"))),
                    ]),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("email.messages.noLinkedEmail.2")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.redirectToSettings },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("client-profile.actions.goToSettings"))
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
      _vm._v(" "),
      _c("confirm-load-email-template-modal", {
        ref: "confirmLoadTemplate",
        attrs: { "template-data": _vm.templateDataForConfirmation },
        on: {
          cancel: _vm.handleCancelTemplateConfirmationModal,
          hide: _vm.handleHideTemplateConfirmationModal,
          submit: _vm.handleSelectTemplateAutocomplete,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preload-error-icon" }, [
      _c("i", {
        staticClass: "fa fa-exclamation-circle",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preload-error-icon" }, [
      _c("i", {
        staticClass: "fa fa-check-circle text-success",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }